/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_KneeInputs */

const en_us2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knee`)
};

const pt_br2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joelho`)
};

const es_419_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodilla`)
};

const pt_pt2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joelho`)
};

const fr_fr2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genou`)
};

const de_de2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knie`)
};

const it_it2_profile_editors_pain_area_knee = /** @type {(inputs: Profile_Editors_Pain_Area_KneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginocchio`)
};

/**
* | output |
* | --- |
* | "Knee" |
*
* @param {Profile_Editors_Pain_Area_KneeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_knee = /** @type {((inputs?: Profile_Editors_Pain_Area_KneeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_KneeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_knee(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_knee(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_knee(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_knee(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_knee(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_knee(inputs)
	return en_us2_profile_editors_pain_area_knee(inputs)
});
export { profile_editors_pain_area_knee as "profile-editors.pain_area_knee" }